import { environment } from "../../environments/environment";

/** Query params shared with the main Treeslo app for footer / legal back links. */
export const NAV_RETURN_FROM_QUERY_PARAM = "from";
export const NAV_RETURN_FROM_HOME = "home";

export const LANDING_TREESLO_APP_URL = environment.treesloAppUrl;

export const LANDING_TREESLO_DASHBOARD_URL = `${environment.treesloAppUrl}${environment.treesloAppPaths.dashboard}`;

/** Where the app should send users when they leave via “Back to Home”. */
export const LANDING_1_RETURN_PATH = environment.marketingReturnUrl;

export const LANDING_TREESLO_APP_PATHS = environment.treesloAppPaths;

export function landingAppUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${environment.treesloAppUrl}${normalized}`;
}

export function landingAppUrlWithReturn(
  path: string,
  returnUrl: string = environment.marketingReturnUrl,
): string {
  const params = new URLSearchParams({
    [NAV_RETURN_FROM_QUERY_PARAM]: NAV_RETURN_FROM_HOME,
    returnUrl,
  });
  return `${landingAppUrl(path)}?${params.toString()}`;
}
